import { useState } from 'react';

// When the current page was opened: its decision waits for answers received after it.
export const useOpenedAt = (pathname: string): number => {
  const [opened, setOpened] = useState(() => ({ at: Date.now(), pathname }));

  if (opened.pathname !== pathname) {
    setOpened(() => ({ at: Date.now(), pathname }));
  }

  return opened.at;
};
